import React, { useState } from 'react'
import { Button, Form, Modal } from 'react-bootstrap';
import { changePasswordUseCase } from '../../di/usecase_module';
import { ChangePasswordRequestDto } from '../../domain/usecases/session/ChangePasswordUseCase';
import { useForm } from '../../presentation/hooks/useForm';
import { useDispatch, useSelector } from 'react-redux';
import { UIActions } from '../../presentation/redux/actions/UIActions';
import { RootState } from '../../presentation/redux/store/RootState';
import { handleError } from '../../presentation/utils/handleError';
import { showSuccessMessage } from '../../presentation/utils/showSuccessMessage';
import { handleLogout } from '../../presentation/utils/handleLogout';
import PasswordStrengthBar from 'react-password-strength-bar';
import Swal from 'sweetalert2';

export const ModalChangePassword = () => {

  const dispatch = useDispatch();
  const uiState = useSelector((s: RootState) => s.uiState)
  const [values, handleInputChange, reset]: any = useForm();
  const [isShowing, setIsShowing] = useState(false);
  const [isShowingConfirm, setIsShowingConfirm] = useState(false);
  const [state, setState] = useState({
    validateForm: false
  })

  const onSubmit = (e: any) => {
    e.preventDefault();
    if (isFormValid()) {
      setState((s) => {
        return {
          ...s,
          validateForm: true
        }
      })

      if (!oldPasswordIsValid() || !newPasswordIsValid() || !confirmPasswordIsValid()) return;

      changePasswordUseCase()
        .execute(new ChangePasswordRequestDto(
          encodeURIComponent(values.oldPassword),
          encodeURIComponent(values.newPassword)
        ))
        .then((_) => {
          showSuccessMessage({
            message: "La contraseña ha sido cambiada exitosamente. Inicia sesión con tu nueva contraseña para continuar"
          }, () => {
            handleHide();
            handleLogout();
          });

        }).catch((e) => {
          handleError(e);
        })
    }

  }
  function handleHide() {
    reset({});
    setState((s) => {
      return {
        ...s,
        validateForm: false
      }
    })
    setIsShowing(false);
    setIsShowingConfirm(false);
    dispatch(UIActions.closeChangePassword());
  }

  function oldPasswordIsValid(): boolean {
    return values.oldPassword !== undefined && values.oldPassword !== "";
  }
  function newPasswordIsValid(): boolean {
    return values.newPassword !== undefined && values.newPassword !== "";
  }
  function confirmPasswordIsValid(): boolean {
    return (values.confirmPassword !== undefined
      && values.confirmPassword !== ""
      && values.confirmPassword === values.newPassword);
  }


  const isFormValid = () => {
    let isValid = true;
    if (values.newPassword && values.newPassword.trim().length < 8) {
      Swal.fire({
        icon: 'warning',
        title: 'Validar contraseña',
        text: 'La nueva contraseña debe tener al menos 8 caracteres'
      });
      isValid = false;
    } else if ((values.newPassword) && (!(/[a-z]/.test(values.newPassword)) || !(/[A-Z]/.test(values.newPassword)) || !(/[0-9]/.test(values.newPassword)))) {
      Swal.fire({
        icon: 'warning',
        title: 'Validar contraseña',
        html:
          'La contraseña debe tener al menos: ' +
          (!(/[a-z]/.test(values.newPassword)) ? '<li><b>una minúscula</b></li> ' : '') +
          (!(/[A-Z]/.test(values.newPassword)) ? '<li><b>una mayúscula</b></li> ' : '') +
          (!(/[0-9]/.test(values.newPassword)) ? '<li><b>un número</b></li> ' : '')
      });
      isValid = false;
    }
    return isValid
  }

  return (
    <Modal
      onHide={handleHide}
      show={uiState.isPasswordOpen}
      backdrop="static"
      aria-labelledby="contained-modal-title-vcenter"
      centered>
      <Modal.Header closeButton
        className='gradientBlue colorWhite'>
        <Modal.Title id="contained-modal-title-vcenter">
          Cambio de contraseña
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form onSubmit={onSubmit}>
          <Form.Group>
            <Form.Label>Contraseña actual</Form.Label>
            <Form.Control
              onChange={handleInputChange}
              id="oldPassword"
              name="oldPassword"
              value={values.oldPassword}
              isInvalid={state.validateForm && !oldPasswordIsValid()}
              type="password"
              placeholder="Contraseña actual" />
            <Form.Control.Feedback type="invalid">Campo obligatorio</Form.Control.Feedback>
          </Form.Group>
          <div className="divider mb-2" />
          <Form.Group>
            <Form.Label>Nueva contraseña </Form.Label>
            <div className='wrap-input-pass'>
              <Form.Control
                id="newPassword"
                name="newPassword"
                value={values.newPassword}
                onChange={handleInputChange}
                isInvalid={state.validateForm && !newPasswordIsValid()}
                type={(isShowing) ? `text` : `password`}
                placeholder="Nueva contraseña" />
              <Form.Control.Feedback type="invalid">Campo obligatorio</Form.Control.Feedback>
              {
                values.newPassword &&
                <button type='button' className='btn btn-show-2'
                  onClick={() => { setIsShowing(!isShowing) }}>
                  <i className={(isShowing) ? `fas fa-eye` : `fas fa-eye-slash`}></i>
                </button>
              }
            </div>
            {values.newPassword &&
              <PasswordStrengthBar
                shortScoreWord='demasiado corta'
                scoreWords={['muy débil', 'débil', 'buena', 'muy buena', 'fuerte']}
                password={values.newPassword} />
            }
          </Form.Group>
          <Form.Group>
            <Form.Label>Confirme nueva contraseña </Form.Label>
            <div className='wrap-input-pass'>
              <Form.Control
                id="confirmPassword"
                name="confirmPassword"
                value={values.confirmPassword}
                onChange={handleInputChange}
                isInvalid={state.validateForm && !confirmPasswordIsValid()}
                type={(isShowingConfirm) ? `text` : `password`} placeholder="Confirme nueva contraseña" />
              <Form.Control.Feedback type="invalid">La contraseña no coincide</Form.Control.Feedback>
              {
                values.confirmPassword &&
                <button type='button' className='btn btn-show-2'
                  onClick={() => { setIsShowingConfirm(!isShowingConfirm) }}>
                  <i className={(isShowingConfirm) ? `fas fa-eye` : `fas fa-eye-slash`}></i>
                </button>
              }
            </div>
          </Form.Group>
          <Button className="float-right mt-2" variant="primary" type="submit">
            Guardar
          </Button>
          <Button onClick={handleHide} className="float-right mt-2 mr-2" variant="secondary">
            Cancelar
          </Button>
        </Form>
      </Modal.Body>
    </Modal>
  )
}
